export const typeOptions = [
  { text: 'Hand Tool', value: 1 },
  { text: 'Machine',   value: 2 },
]

export const statusOptions = [
  { text: 'Working',   value: 1 },
  { text: 'Not Working', value: 2 },
  { text: 'Archived', value: 3 },
  { text: 'Deleted', value: 4 },
]

export function typeName(v)   { return (typeOptions.find(o => o.value === v) || {}).text || '—' }
export function statusName(v) { return (statusOptions.find(o => o.value === v) || {}).text || '—' }
export function formatDate(d) { if (!d) return '—'; return new Date(d).toLocaleDateString('hu-HU') }
export function typeHex(v)    { return { 1: '#f59e0b', 2: '#3b82f6' }[v] || '#94a3b8' }
export function typeGlyph(v)  { return { 1: '🔧', 2: '⚙️' }[v] || '◎' }